import { render } from "./zoho-payments.vue?vue&type=template&id=43ca80cc"
import script from "./zoho-payments.vue?vue&type=script&lang=js"
export * from "./zoho-payments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__